

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueResouce from "vue-resource";
import VueBetterScroll from 'vue2-better-scroll'
import mapMethod from './utils/uniteApi/map-public-method.js' 
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import MintUI from "mint-ui";
import "mint-ui/lib/style.css";
import moment from "moment";
Vue.prototype.$moment = moment;
import fastclick from "fastclick";
import VConsole from "vconsole";
import pageComponent from '@/components/page-component/page-component.vue'
import 'echarts-wordcloud/dist/echarts-wordcloud'
import 'echarts-wordcloud/dist/echarts-wordcloud.min'
import BaiduMap from 'vue-baidu-map'

Vue.use( BaiduMap, { ak : 'fL2FcYbfrpZ4Pg1e6Or2PGc44V9C4mzo' } )
fastclick.attach(document.body);


Vue.component('page-component', pageComponent)
Vue.prototype.$mapMethod = mapMethod
Vue.config.productionTip = false;
Vue.use(LoadingPlugin);
Vue.use(VueResouce);
Vue.use(MintUI);
Vue.use(VueBetterScroll);


Vue.directive("addComma", (el, binding) => {
const number = Number(binding.value)
const str = number.toString().replace(/\d+/, (n) => {
return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
return $1 + ',';
});
});

el.innerHTML = str
})

/**
* 手机上测试打印console的包 vconsole
*/


Vue.http.interceptors.push((request, next) => {
request.credentials = true;
request.emulateJSON = true;
request.timeout = 120 * 1000; 

let timeout;
if (request.timeout) {
timeout = setTimeout(() => {

request.abort();
}, request.timeout);
}
next(rep => {
clearTimeout(timeout);
let result = rep.body;
if (rep.status === 0) {
MintUI.MessageBox.alert("请求失败", "操作提示");
}
if (!result.success) {

if (result.code && result.code === "12") {
MintUI.MessageBox.alert(result.message, "操作提示").then(() => {
router.push({
name: "login"
});
});
} else {
return rep;
}
} else {
return rep;
}
});
});
/* eslint-disable no-new */

new Vue({
el: "#app",
router,
store,
components: { App },
template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js